export const setTitle = (title?: string) => {
  if (title != null && !!document) {
    document.title = title;
  }
};
